import type { RenderComponentProps } from "replo-runtime/shared/types";
import type { Component } from "schemas/component";

import React from "react";

import unescape from "lodash-es/unescape";

import { useBundleBuilder } from "../BundleBuilderContext";

const getCustomProps = (props: Component["props"]) => {
  const { subtotalText, savingsText, totalText } = props;
  return {
    subtotalText: subtotalText as string | null,
    savingsText: savingsText as string | null,
    totalText: totalText as string | null,
  };
};

export const BundleCartTotals: React.FC<RenderComponentProps> = ({
  componentAttributes,
  component,
}) => {
  const { subtotalText, savingsText, totalText } = getCustomProps(
    component.props,
  );
  const { getBundleTotals, getBundleTotalQuantity } = useBundleBuilder();
  const { total, subTotal, savings } = getBundleTotals();
  const totalQuantity = getBundleTotalQuantity();
  return (
    totalQuantity > 0 && (
      <div
        {...componentAttributes}
        style={{
          flexDirection: "column",
          gap: "6px",
          ...componentAttributes?.style,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "16px",
            lineHeight: "20px",
          }}
        >
          <span>{subtotalText ?? "Subtotal"}</span>
          <span dangerouslySetInnerHTML={{ __html: unescape(subTotal) }} />
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "16px",
            lineHeight: "20px",
          }}
        >
          <span>{savingsText ?? "Savings"}</span>
          <span dangerouslySetInnerHTML={{ __html: unescape(savings) }} />
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "16px",
            lineHeight: "20px",
            fontWeight: "bold",
          }}
        >
          <span>{totalText ?? "Total"}</span>
          <span
            style={{ color: "#2a9d8f" }}
            dangerouslySetInnerHTML={{ __html: unescape(total) }}
          />
        </div>
      </div>
    )
  );
};
